var disposed = false
var Component = require("!../../../../.12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../.12.2.2@vue-loader/lib/selector?type=script&index=0!./tag.vue"),
  /* template */
  require("!!../../../../.12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6715304f\",\"hasScoped\":false}!../../../../.12.2.2@vue-loader/lib/selector?type=template&index=0!./tag.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "E:\\LemonProject\\npm-project\\element-table-column-edit\\node_modules\\.1.4.12@element-ui\\packages\\tag\\src\\tag.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] tag.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6715304f", Component.options)
  } else {
    hotAPI.reload("data-v-6715304f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/.1.4.12@element-ui/packages/tag/src/tag.vue
// module id = 17
// module chunks = 0